// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '98efb9b9ac8cf071ca83a9b6f2b289c7a194a011';
export const BUILD_NUMBER = '242';
export const BUILD_TIMESTAMP = '2026-09-16T11:03:27.491Z';
